import { StoryData } from 'storyblok-js-client';

export interface StoryblokGlobalContentState {
  promoWidgetLink: StoryData;
  navigation: StoryData;
  offerMenuContent: StoryData;
  isLoaded: boolean;
  error: string;
}

export const storyblokGlobalContentInitialState: StoryblokGlobalContentState = {
  promoWidgetLink: null,
  navigation: null,
  offerMenuContent: null,
  isLoaded: false,
  error: null,
};
